/**
 * @generated SignedSource<<306616f326f50fa85938b9546ca7ce26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type datalevel = "CJIS" | "EXTERNAL" | "INTERNAL" | "PRESALE" | "SECRET" | "TRIAL" | "UNKNOWN" | "%future added value";
export type useOrgDataLevelQuery$variables = {
  orgUuid: string;
  skip: boolean;
};
export type useOrgDataLevelQuery$data = {
  readonly organization?: {
    readonly dataLevel: datalevel;
    readonly id: string;
  } | null;
};
export type useOrgDataLevelQuery = {
  response: useOrgDataLevelQuery$data;
  variables: useOrgDataLevelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgUuid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "uuid",
            "variableName": "orgUuid"
          }
        ],
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dataLevel",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useOrgDataLevelQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useOrgDataLevelQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d89de877370d669fabbf1c96647d7001",
    "id": null,
    "metadata": {},
    "name": "useOrgDataLevelQuery",
    "operationKind": "query",
    "text": "query useOrgDataLevelQuery(\n  $orgUuid: String!\n  $skip: Boolean!\n) {\n  organization(uuid: $orgUuid) @skip(if: $skip) {\n    id\n    dataLevel\n  }\n}\n"
  }
};
})();

(node as any).hash = "07d2c90d3a161af826d6b493670c5b96";

export default node;
